<template>
  <div>
    <v-dialog/>
    <div class="admin_title border_bt">机构信息</div>
    <!--右侧内容-->
    <form class="class_add_con" data-vv-scope="form" novalidate>
      <div class="enterpise_top">
        <dl>
          <!--dt>购买模块</dt-->
          <dd>
            <p class="mt15"><span v-if="form.isGroup == '1'">机构版</span><span v-if="form.isGroup == '2'">集团版</span><!--a href="" class="buy_btn">购买模块</a--></p>
            <!--p class="mt15">截止日期：2018年06月22日&nbsp;&nbsp;<a href="">申请续期</a></p>
            <p class="mt30">已购买模块：</p>
            <p class="mt5">
            <input name="" type="checkbox" value="2" class="on"/> 资源课程　　
            <input name="ziyuan" type="checkbox" value="6"  class="on"/> 资源课程　　
            <input name="ziyuan" type="checkbox" value="7"  class="on"/> 资源课程　　
            <input name="ziyuan" type="checkbox" value="8"  class="on"/> 资源课程
            </p-->
          </dd>
        </dl>
      </div>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td class="left_td pt20">机构名称：</td>
          <td class="pt20"><input name="" type="text" class="put_495 w300"  v-model="form.name" /></td>
        </tr>
        <tr>
          <td class="left_td pt20">机构规模：</td>
          <td class="pt20">
            <!--input name="" type="text" class="put_495 w300"  v-model="form.member" /-->
            <select name="member" v-model="form.member" v-validate="'required'" class="select_put">
              <option value="">机构规模</option>
              <option v-for="item in selects" :key="item.id" :value="item.value">{{item.label}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="left_td" valign="top">机构LOGO：</td>
          <td class="rdiv pt10">
            <img v-if="form.logo && form.logo!==''" :src="form.logo"  class="upload_img" />
            <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'logo'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
            <p class="mt10"><span class="tips_text">建议图片长210px宽80px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
          </td>
        </tr>
        <tr>
          <td class="left_td pt20">机构代码：</td>
          <td class="pt20"><input name="" type="text" class="put_495 w300"  v-model="form.code" /></td>
        </tr>
        <tr>
          <td class="left_td pt20">域名设置：</td>
          <td class="pt20"><input name="" type="text" class="put_495 w300"  v-model="form.domain" /></td>
        </tr>
        <tr>
          <td class="left_td">对外公开：</td>
          <td>
            <input name="address" type="radio" v-model="form.isOpen" value="1" />
            公开
            <input name="address" type="radio" v-model="form.isOpen" value="0" />
            不公开&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="tips_text">开启后所有信息都即将公开</span></td>
        </tr>
        <tr>
          <td class="left_td">课程是否审核：</td>
          <td>
            <input name="class" type="radio" value="1" v-model="form.isAudit" />
            需审核
            <input name="class" type="radio" value="0" v-model="form.isAudit" />
            不审核
            <span class="tips_text">开启后新增课程需要审核通过才可展示</span></td>
        </tr>
      </table>
      <p class="btn_center">
        <input name="" type="button" class="all_btn" value="保存提交" @click="validateForm('form')" />
      </p>
    </form>
    <!--/右侧内容-->
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import { getCookie } from '@/store/cookies'
    export default {
      components: { UploadOSS },
      data () {
        return {
          form: {},
          selects: [],
          uploadOSSConf: { showMode: '1', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
        }
      },
      mounted () {
        this.getOrgIdByCode(process.env.DEFAULT_ORGCODE).then((r) => {
          if (r) {
            let orgid = r[0].id
            this.getModel(orgid)
          }
        })
        this.getSelects()
        this.getSTS()
        this.OSSUploadSuccess()
      },
      methods: {
        popup (msg) {
          this.$toasted.show(msg)
        },
        confirmBox (o) {
          var that = this
          this.$modal.show('dialog', {
            title: '提交',
            text: '确认提交吗？',
            buttons: [
              {
                title: '确认',
                default: true,
                handler: utils.debounce(() => {
                  if (o.yes && o.yes instanceof Function) {
                    o.yes()
                    that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                  }
                }, 1000)
              },
              {
                title: '取消'
              }
            ]
          })
        },
        validateForm (scope) {
          var bus = this
          this.$validator.validateAll(scope).then(function (result) {
            if (result) {
              bus.confirmBox({
                yes: function () {
                  api.post(config.bylApiPath, '/entInfo/save', bus.form, function (r) { // 正常
                    bus.popup('更新成功')
                    // bus.getModel(getCookie('org').id)
                    bus.$modal.hide('dialog')
                  })
                }
              })
            } else {
              bus.$toasted.show('请确保信息正确与完整')
              return false
            }
          })
        },
        getModel (id) {
          var that = this
          api.post(config.bylApiPath, '/entInfo/get', { id: id }, function (r) { // 正常
            that.form = r.data
            that.$emit('data-prepared', that.form)
          })
        },
        OSSUploadSuccess (r) {
          if (r && r != '') {
            this.$set(this.form, r.dom_id, r.res.requestUrls[0])
          }
        },
        getSTS () {
          this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
            let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
            this.uploadOSSConf.STS = STS
          })
        },
        getSelects () {
          var that = this
          api.get(config.bylBaseCenterPath, '/dict/findList', {
            type: 'entMember',
            pageNo: 1,
            pageSize: 100
          }, function (r) { // 正常
            that.selects = r.data
          })
        },
        getOrgIdByCode (code) {
          return new Promise(function (resolve, reject) {
            api.post(config.bylApiPath, '/entInfo/search', {code: code}, function (r) { // 正常
              resolve(r.data)
            })
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/orginfo/list.vue